<template>
    <el-dialog
    class="setting-dialog"
    title="编辑合作单位"
    :visible.sync="settingVisible"
    width="50%"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose">
    <div class="table-container">
      <setting-table
        :listen-height="false"
        :refresh="tableInfo.refresh"
        :data.sync="tableInfo.data"
        :pager="false"
        :field-list="tableInfo.fieldList"
        :handle="tableInfo.handle"
        @handleClick="handleClick"
      >
        <!-- 自定义列表内容 -->
        <template v-slot:col-state="scope">
          <p>{{ scope.row.state === 1 ? '已停用' : '已启用' }}</p>
        </template>
        <!-- 自定义插槽状态按钮 -->
        <template v-slot:bt-state="scope">
          <el-button
            :type="'text'"
            @click="handleClick(scope.data.item.event, scope.data.row)"
          >
            {{ scope.data.row.state === 2 ? '停用' : '启用' }}
          </el-button>
        </template>
      </setting-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关 闭</el-button>
    </span>
    </el-dialog>
</template>

<script>
import SettingTable from '@/components/PublicTable';
export default {
  components: {
    SettingTable
  },
  props: {
    settingVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tableInfo: {
        refresh: 1,
        initTable: false,
        data: [],
        query: {},
        fieldList: [
          { label: '分类名称', value: 'classifyName'},
          { label: '状态', value: 'state', type: 'slot' }
        ],
        handle: {
          label: '操作',
          btList: [
            { label: '启用', type: 'text', event: 'state', show: true, slot: true }
          ]
        }
      }
    }
  },
  methods: {
    init(data) {
      if (data) {
        this.tableInfo.data = data;
        return;
      }
    },
    handleClose() {
      this.$emit('setting-close');
    },
    // table操作
    handleClick(event, row) {
      if (event === 'state') {
        this.$emit('update-state', row);
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .setting-dialog {
    ::v-deep .el-dialog {
      .el-dialog__header {
        // background-color: #909399;
        padding: 10px;
        .el-dialog__title {
          font-size: 15px;
          // color: #fff;
        }
        .el-dialog__headerbtn {
          top: 10px;
          i {
            // color: #fff;
          }
        }
      }
      .el-dialog__body {
        max-height: 500px;
        overflow-y: scroll;
      }
      .el-dialog__footer {
        width: 100%;
        border-top: 1px solid #ddd;
        padding-top: 15px;
      }
    }
  }
</style>